<script lang="ts">
  
  import { clickOutside } from '../utils/click-outside'
  import ShopifyImage from './ShopifyImage.svelte'

  export let floating = true;
  export let search = '';

  export let classList = 'focus:ring-primary focus:border-primary rounded-lg py-2 px-4 w-full';

  export let placeholder = 'Search for products';

  export let type = '';

  let articles: any[] = []
  let products: any[] = []
  let collections: any[] = []
  let queries: any[] = []
  let isOpen = !floating;

  let selectedIndex = 0;

  export let inputEl;

  $: {
    if (search.length > 2 && isOpen) {
      let params = [
        ['q', search]
      ];

      if (type) {
        params.push(['resources[type]', type]);
      }

      fetch('/search/suggest.json?' + new URLSearchParams(params))
        .then((response) => response.json())
        .then(({ resources }) => {
          queries = resources.results.queries || []
          products = resources.results.products || []
          collections = resources.results.collections || []
          articles = resources.results.articles || []
        })
    }
  }

  function onKeyDown(event: KeyboardEvent) {
    if (event.key == 'ArrowUp') {
      selectedIndex--

      event.stopPropagation()
    }
    if (event.key == 'ArrowDown') {
      selectedIndex++

      event.stopPropagation()
    }
  }

  function onSubmit(event: Event) {
    if (selectedIndex !== 0) {
      event.preventDefault()
    }

    if (articles.length && selectedIndex > 0 && selectedIndex <= articles.length) {
        let article = articles[selectedIndex - 1] || { url: '' }
        
        return window.location.replace(article.url)
    }

    if (selectedIndex > collections.length + queries.length) {
        let product = products[selectedIndex - queries.length - collections.length - 1] || { handle: '' }

        return window.location.replace(`/products/${product.handle}`)
    } 
    if (selectedIndex > queries.length) {
        let collection = collections[selectedIndex - queries.length - 1] || { handle: '' }

        return window.location.replace(`/collections/${collection.handle}`)
    }

    let query = queries[selectedIndex - 1] || { handle: '' }

    window.location.href = query.url
  }

  $: maxlength = products.length + collections.length + queries.length + articles.length
  $: if (selectedIndex > maxlength) selectedIndex = 0
  $: if (selectedIndex < 0) selectedIndex = maxlength
</script>

<form
  action="/search"
  class="relative"
  on:submit={onSubmit}
  use:clickOutside={() => (isOpen = false)}
>
{#if type}
  <input type="hidden" name="type" value={type} />
{/if}
<div class="relative">
  <input
    type="search"
    on:keydown={onKeyDown}
    {placeholder}
    name="q"
    class={classList + ' pl-10'}
    class:text-2xl={!floating}
    bind:value={search}
    bind:this={inputEl}
    autocomplete="off"
    on:focus={() => (isOpen = true)}
  />
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    stroke-width='1.5'
    stroke='currentColor'
    class='w-5 h-5 absolute top-1/2 -mt-2.5 left-3 pointer-events-none'
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
  </svg>
</div>
  {#if isOpen && (products.length || articles.length) && search.length > 2}
    <div
      class="z-50 p-2 rounded-b shadow top-12 inset-x-0 bg-white divide-y border border-gray-100 divide-gray-100 max-h-[80vh] rounded"
      class:absolute={floating}
      class:overflow-y-auto={floating}
    >
      <div class="divide-y divide-gray-100" >
        {#each queries as query, index}
          <a
            href={query.url}
            class:bg-gray-100={selectedIndex == index + 1}
            class="flex align-middle gap-2 md:rounded px-2 py-2 hover:bg-gray-100"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-5 mx-1">
                <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
            </svg>
          
            <span class="[&>mark]:font-bold [&>mark]:text-primary [&>mark]:bg-transparent">
                {@html query.styled_text || query.text}
            </span>
          </a>
        {/each}
      </div>
      {#each articles as article, index}
          <a
            href={article.url}
            class:bg-gray-100={selectedIndex == index + queries.length + 1}
            class="flex align-left items-center gap-2 md:rounded px-2 py-2 hover:bg-gray-100"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 shrink-0 mx-1">
                <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
            </svg>
          
            <span class="text-ellipsis overflow-hidden whitespace-nowrap">
            {article.title}
          </span>
          </a>
        {/each}
      {#if collections.length}
        <div class="divide-y divide-gray-100">
          {#each collections as result, index}
            <a
              href="/collections/{result.handle}"
              class="flex align-middle gap-2 md:rounded px-2 py-2 hover:bg-gray-100"
              class:bg-gray-100={selectedIndex == index + queries.length + 1}
            >
              <svg class="w-6 h-5 mx-1 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6Z" />
              </svg>
              
              {result.title}
            </a>
          {/each}
        </div>
      {/if}
      <div class="divide-y divide-gray-100">
        {#each products as result, index}
          <a
            href="/products/{result.handle}"
            class:bg-gray-100={selectedIndex == index + queries.length + collections.length + 1}
            class="flex align-middle items-center gap-2 md:rounded px-2 py-1 hover:bg-gray-100"
          >
            <span class="block flex-shrink-0 w-8 h-12 rounded bg-secondary">
              <ShopifyImage
                classList="w-full h-full object-cover object-center mix-blend-multiply"
                loading="eager"
                image={result.featured_image}
                sizes={`200px`}
              />
            </span>
            <span>
              {result.title}
            </span>
          </a>
        {/each}
      </div>

      <div class="pt-2" >
        <button
          type="submit"
          class:bg-gray-100={selectedIndex == maxlength + 1}
          class="block w-full text-left md:rounded px-2 py-1 hover:bg-gray-100"
        >
          All search results
        </button>
      </div>
    </div>
  {/if}
</form>
